import { render, staticRenderFns } from "./ModificaZona.vue?vue&type=template&id=07eb249a&scoped=true&"
import script from "./ModificaZona.vue?vue&type=script&lang=js&"
export * from "./ModificaZona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07eb249a",
  null
  
)

export default component.exports